import { render, staticRenderFns } from "./Imperial.vue?vue&type=template&id=197352ec&scoped=true"
import script from "./Imperial.vue?vue&type=script&lang=js"
export * from "./Imperial.vue?vue&type=script&lang=js"
import style0 from "./Imperial.vue?vue&type=style&index=0&id=197352ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197352ec",
  null
  
)

export default component.exports